import { css } from '@emotion/core';

const styles = () => ({
  backButton: css`
    align-self: flex-start;
  `,
  selectedSectionWrapper: css`
    border-bottom: 1px solid rgba(118, 118, 118, 0.5);
  `,
  selectedSectionHeader: css`
    padding: 10px;
    font-weight: bold;
  `,
  selectedSectionDescription: css`
    margin-left: 10px;
    margin-bottom: 15px;
  `
});

export default styles;
